import {Injectable} from '@angular/core';
import {CanActivate, CanLoad, Router, NavigationEnd, NavigationStart, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import { filter, map, take} from 'rxjs/operators';
import { ConfirmPhoneComponent } from "@patientlynk3/components/confirm-phone/confirm-phone.component"

import { AuthQuery } from '@patientlynk3/services/auth/auth.query';
import { ProfileService } from '@patientlynk3/services/profile/profile.service'
import { ApiService } from '@patientlynk3/services/api/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private modal: NgbModal, protected auth: AuthService, protected router: Router, private query: AuthQuery, public profile: ProfileService, private api: ApiService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) { return this.loginGuard(route, state); }
  canLoad() { return this.loginGuard(null, null); }
  triggerModal(profileResonse){
    profileResonse.phones.forEach(element => {
        if(element.primary && element.confirmed == false){
          // this.router.navigate(['/home'])
          let modalRef = this.modal.open(ConfirmPhoneComponent, {
            backdrop : 'static',
            keyboard : false,
            windowClass: 'confirm-phone-modal',
            size: 'xl'
          }).result.then((data) => {
          }).catch((res) => {
          });
        }
    });

    if (profileResonse.phones.length == 0) {
      let modalRef = this.modal.open(ConfirmPhoneComponent, {
        backdrop : 'static',
        keyboard : false,
        windowClass: 'confirm-phone-modal',
        size: 'xl'
      }).result.then((data) => {
      }).catch((res) => {
      });
    }
  }

  protected async loginGuard(route, state) {    

    const isLoggedIn = await this.auth.isLoggedIn$
      .pipe(take(1)).toPromise();

    // this.profile.$testprofile.subscribe((data) => {
    //   console.log("this.$testprofile", data);
    // })


    let profile = await this.query.payload$.pipe(take(1)).toPromise();
    let profileService = await this.profile.getValue();
    
    if (!isLoggedIn) {      
      this.router.navigate(['/login'], { state: { returnUrl: state.url }});
    }
    
    if (isLoggedIn == true) {  
          
      if (profile.has_accepted_terms == false) {
        setTimeout(() => {
          console.log("window.location.href", window.location.pathname);
          console.log("----------------------------------------");          
          console.log("isLoggedIn", isLoggedIn);
          console.log("has_accepted_terms", profile.has_accepted_terms);
          console.log("window.location.href", window.location.pathname);
          console.log("----------------------------------------");

          if (window.location.pathname != '/privacy_settings/terms') {
            this.router.navigate(['/privacy_settings/terms'])
          }    
        }, 1000);
      }

      console.log("profileService", profileService);
      
      if (Object.keys(profileService).length > 0) {
        this.triggerModal(profileService)
      } else {
        this.api.getProfile().subscribe((data) => {
          this.triggerModal(data)
        })
      }
    }

    let loggedAndReady = false    



    if (state.url != "/home" && state.url != "") {            
      loggedAndReady = isLoggedIn
    } else {      
      loggedAndReady = isLoggedIn
    }
    
    console.log("profileService", profileService);
    console.log("loggedAndReady", loggedAndReady);
    
        
    return loggedAndReady;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(protected auth: AuthService, protected router: Router, public profile: ProfileService) {}

  async canActivate() {
    const isLoggedIn = await this.auth.isLoggedIn$
      .pipe(take(1)).toPromise();

    if (isLoggedIn) {
      console.log("this.profile", this.profile.getValue());
      
      this.router.navigate(['/home']);
    }

    return !isLoggedIn;
  }
}
